export default "__VITE_ASSET__Y5RK5ZZe__"